const React = require('react');
const PropTypes = require('prop-types');
const {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} = require('react-simple-maps');
const { scaleLinear } = require('d3-scale');
const geographyData = require('./world-50m.json');


const ChoroplethWorld = ({ countriesExcluded, countryKey, countrySelected, data, dataKey, fillSelected, fillRange }) => {
    const maxValue = data ? data.reduce((max, v) => v[dataKey] > max ? v[dataKey] : max, 0) : 0;
    const popScale = scaleLinear().domain([0, maxValue]).range(fillRange);
    let fillGeography = null;
    if(data) {
    fillGeography = geography => data.some(d => d[countryKey] === geography.id )
        ? popScale(data.find(d => d[countryKey] === geography.id).value)
        : popScale(0);
    }
    if(fillGeography) {
    return (
        <ComposableMap
            projectionConfig={{
            scale: 205,
            rotation: [-11,0,0],
        }}
            width={980}
            height={551}
            style={{
            width: "100%",
            height: "auto",
        }}
        >
            <ZoomableGroup center={[0,20]} disablePanning>
                <Geographies geography={geographyData} disableOptimization>
                    {
                    (geographies, projection) => geographies.map((geography, i) => !countriesExcluded.includes(geography.id) && (
                    <Geography
                        key={i}
                        geography={geography}
                        projection={projection}
                        style={{
                            default: {
                                fill: geography.id === countrySelected
                                ? fillSelected
                                : fillGeography(geography)
                            },
                            hover: {
                                fill: fillGeography(geography),
                            },
                        }}
                        />
                    ))
                    }
                </Geographies>
            </ZoomableGroup>
        </ComposableMap>
        );
    } else {
        return null;
    }
};


ChoroplethWorld.defaultProps = {
    countriesExcluded: ["ATA"],
    countryKey: 'country',
    dataKey: 'value',
    fillRange: ["#e3e9e9","#e3e9e9"],
    fillSelected: "#2ccefd",
};

ChoroplethWorld.propTypes = {
    countriesExcluded: PropTypes.array,
    countryKey: PropTypes.string,
    countrySelected: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    data: PropTypes.array.isRequired,
    dataKey: PropTypes.string,
    fillRange: PropTypes.array,
    fillSelected: PropTypes.string,
};


module.exports = ChoroplethWorld;
